const errors = {
  'Access Denied': "You don't have permission to take this action",
};

const normalizeErrorMessage = (error) => errors[error] || error;

export const textifyError = (error, deep = 0) => {
  if (deep > 10) error = 'Max callstack size reached';

  if (error && error.constructor === [].constructor) {
    return error.map(e => textifyError(e, deep + 1)).join('\ncaused by: ');
  }

  if (error && typeof error.title === 'string' && typeof error.body === 'string') {
    return Object.values(error).join('\ncaused by: ');
  }

  if (typeof error === 'symbol') return 'unknown symbol';
  if (typeof error !== 'object' || error === null) return normalizeErrorMessage(String(error));
  if (typeof error.message === 'string') return normalizeErrorMessage(error.message);
  if (typeof error.error === 'string') return normalizeErrorMessage(error.error);

  console.error('unknown error object:');
  console.error(error);
  return `unknown error object:${JSON.stringify(error)}`;
};

export const errorsToObject = (error) => {
  if (error && typeof error.title === 'string' && typeof error.body === 'string') return error;
  if (!error || error.constructor !== [].constructor) error = [error];
  error = error.filter(e => e);

  const [message, ...cases] = error;
  return {
    title: textifyError(message),
    body: cases.length ? `${textifyError(cases)}` : ''
  };
};

export class NoAccessToIncidentWorkflowsError extends Error {}
